import '@/Styles/main.scss';
import Vue from 'vue';
import Careers from './Components/Careers/search.vue';
import { utils } from './Util';

(($) => {
    $(() => {
        // Build the careers component
        $('.c-careers').each((i, el) => {
            const careers = new Vue({
                el,
                components: {
                    'careers': Careers,
                }
            });
        });

        $('.c-tab-group').each((i, el) => {
            // About Page tabbed area.
            // TODO: This can be broken up better
            const tabbed = new Vue({
                el,
                data: {
                    open: [],
                    grid: null,
                    selectedId: false,
                    selectedGroup: false,
                    groups: {},
                    groupOrder: {},
                },
                methods: {
                    // Checks if the open item was clicked last
                    isActive(id) {
                        return this.open.slice(-1)[0] === id;
                    },

                    // Checks if the item is left open
                    isOpen(id) {
                        return this.open.includes(id);
                    },

                    // Toggles an item in and out of the array, unless set with a value
                    toggleTab(id, set = false) {
                        const target = $(`#${id}`);
                        if (set) {
                            this.open = [id];
                            $('.tab.accordion').hide();
                            target.show();
                            setTimeout(this.relayout, 10)
                        } else {
                            const action = this.open.includes(id) ? 'slideUp' : 'slideDown';
                            const i = this.open.indexOf(id);

                            if (i === -1) {
                                this.open.push(id);
                            } else {
                                this.open.splice(i, 1);
                            }
                            target[action](() => this.relayout());
                        }
                    },
                    relayout() {
                        if (this.isActive('awards')) {
                            this.grid.isotope("layout");
                        }
                    },
                    loadPerson(id, group = this.selectedGroup) {
                        this.selectedId = id;
                        this.selectedGroup = group;
                        this.open = ['leadership'];

                        this.scrollToEl($('#leadership'));
                        $('#leadership').css({ display: 'block' });
                    },
                    nextPerson()
                    {
                        const ids = this.groupOrder[this.selectedGroup];
                        const index = ids.indexOf(this.selectedId);
                        this.loadPerson(ids[index + 1] || ids[0]);
                    },
                    prevPerson()
                    {
                        const ids = this.groupOrder[this.selectedGroup];
                        const index = ids.indexOf(this.selectedId);
                        this.loadPerson(ids[index - 1] || ids[ids.length - 1]);
                    },
                    clearPerson()
                    {
                        this.selectedId = null;
                        this.$nextTick(() => {
                            this.scrollToEl($(`.leader-slider[data-leader-group='${this.selectedGroup}']`));
                        });
                    },
                    scrollToEl(el)
                    {
                        const scrollPos = el.offset().top - $('#header-container').height();
                        $(window).scrollTop(scrollPos);
                    },
                    relatedArticleLabel(type) {
                        switch (type) {
                            case "newsroomArticle":
                                return "Article";
                            case "pressRelease":
                                return "News Release";
                            case "externalArticle":
                                return "In the News";
                            default:
                                return type;
                        }
                    }
                },
                computed: {
                    selectedLeader() {
                        return this.selectedGroup && this.selectedId
                            ? this.groups[this.selectedGroup][this.selectedId]
                            : null;
                    },
                    isThoughtLeadership() {
                        return this.selectedLeader.Tags.includes("Thought Leaders");
                    },
                },
                mounted()
                {
                    // Handle Isotope grids
                    const isogrid = $(this.$el).find('.grid');
                    if (isogrid.length) {
                        this.grid = isogrid.isotope({
                            itemSelector: '.grid-item',
                            percentPosition: true,
                            masonry: {
                                // use outer width of grid-sizer for columnWidth
                                columnWidth: '.award-grid-sizer',
                                gutter: '.award-gutter-sizer'
                            }
                        });
                    }

                    // Handle Active Tabs
                    const activeTab = $(this.$el).data('section');
                    const actualTab = $(`#${activeTab}`);
                    const isValidTabQuery = actualTab.is('.tab.accordion') || actualTab.is('.sub-tab');

                    if (activeTab && actualTab.length && isValidTabQuery) {
                        const parentTab = actualTab.is('.tab.accordion')
                            ? activeTab
                            : actualTab.parents('.tab.accordion')[0].id;
                        const accepted = $('.tab-panels .tab.accordion').map((i, el) => el.id).get();
                        if (accepted.includes(parentTab)) {
                            this.toggleTab(parentTab, true);
                            setTimeout(() => {
                                this.scrollToEl(actualTab);
                            }, 750);
                        }
                    } else if (actualTab.length) {
                        setTimeout(() => {
                            this.scrollToEl(actualTab);
                        }, 750);
                    }

                    $(this.$el).find('.leader-slider').each((i, el) => {
                        const groupName = $(el).data('leader-group');
                        const groupSet = $(el).data('leader-set');
                        const order = $(el).data('leader-ids');

                        this.$set(this.groups, groupName, groupSet);
                        this.$set(this.groupOrder, groupName, order);
                    });

                    const personQuery = $("#leadership").data('person-id');
                    if (personQuery) {
                        $.each(this.groupOrder, (i, v) => {
                            if (v.includes(personQuery)) {
                                this.loadPerson(personQuery, i);
                                return false;
                            }
                        });
                    }
                }
            });
        });

        // Featured Careers (We don't need a component for this yet, it's just an API call)
        if ($('#careers-featured-positions').length) {
            const featured = new Vue({
                el: '#careers-featured-positions',
                data: {
                    results: [],
                    ready: false
                },
                methods: {
                    stateToAbbr: utils.abbr.stateToAbbr,
                    countryToAbbr: utils.abbr.countryToAbbr,
                    sortedLocations(locations) {
                        return utils.array.clone(locations).sort(utils.sorts.sortLocation);
                    },
                },
            });
            $.ajax({
                dataType: "json",
                url: '/api/v1/careers/Featured',
                success: (data) => {
                    setTimeout(() => {
                        featured.ready = true;
                        featured.results = data.Entities;
                    }, 5000)
                    
                }
            });
        }
    });



})(jQuery);



// WEBPACK FOOTER //
// ./Assets/Scripts/main.js